import React, { useEffect } from "react";

const CrisisManagement = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="px-4 sm:px-32 pt-4 sm:pt-28">
      <h1 className="text-3xl font-bold mb-12">Crisis Management</h1>
      <h2 className="text-xl mt-8 mb-3 font-semibold">
        Information Security Policy:
      </h2>
      <p className="mb-6">
        Fogteams is committed to protecting the confidentiality, integrity, and
        availability of our information assets.
      </p>
      <p className="mb-6">
        Our Information Security Policy is designed to ensure that all employees
        understand their responsibilities in safeguarding these assets.
      </p>
      <p className="mb-6">
        The policy covers areas such as access control, data classification,
        incident response, and security training.
      </p>
      <h2 className="text-xl mt-8 mb-3 font-semibold">
        {`Cyber Crisis Management Plan (CCMP):`}
      </h2>
      <p className="mb-6">
        Yes, FogTeams has a Cyber Crisis Management Plan (CCMP) in place. The
        CCMP outlines the procedures and steps to be taken in the event of a
        cyber incident or breach. The key components of our CCMP include:
      </p>
      <p className="mb-6">
        Incident Response Team: This team manages the response to a cyber crisis
        and includes members from various departments such as IT, legal,
        communications, and senior management. Right now this consists of
        Tanmay, Lokesh, and Kanik.
      </p>
      <p className="mb-6">
        Incident Identification and Classification: The plan outlines the
        procedures for detecting and classifying incidents based on their
        severity and potential impact. This helps in prioritizing the response
        efforts and allocating resources accordingly.
      </p>
      <p className="mb-6">
        Communication Protocols: Clear communication protocols are established
        to ensure timely and accurate information sharing among the members of
        IRT, stakeholders, customers, and external parties such as law
        enforcement or regulatory bodies. We have predefined templates for all
        internal and external communications.
      </p>
      <p className="mb-6">
        Containment and Eradication: Steps to be taken to contain the incident
        and prevent further damage. This includes isolating affected systems,
        removing malicious access elements, and implementing security patches.
      </p>
      <p className="mb-6">
        Containment and Eradication: Steps to be taken to contain the incident
        and prevent further damage. This includes isolating affected systems,
        removing malicious access elements, and implementing security patches.
      </p>
      <p className="mb-6">
        Recovery and Restoration: This is the procedure for restoring affected
        services and systems to normal operations. This involves data recovery,
        system reinstatement, and validation checks to ensure the integrity and
        security of the restored systems.
      </p>
      <p className="mb-6">
        Post-Incident Review: After the resolution of a cyber incident, a
        post-incident review will be conducted to analyze the effectiveness of
        the response, identify lessons learned, and make necessary adjustments
        to the CCMP and other security measures.
      </p>
      <p className="mb-6">
        Training and Awareness: Regular training and awareness programs are
        conducted to ensure that all employees of the organization, including
        the members of the IRT, are prepared to respond effectively to a cyber
        crisis. This includes simulations and drills to test the CCMP and refine
        response procedures.
      </p>
      <p className="mb-6">
        Legal and Regulatory Compliance: We ensure compliance with relevant
        laws, regulations, and industry standards. This includes reporting
        requirements and collaboration with regulatory bodies as necessary.
      </p>
      <h2 className="text-xl mt-8 mb-3 font-semibold">
        Dedicated Information/Cyber Security Team:
      </h2>
      <p className="mb-6">
        FogTeams has a dedicated team responsible for the information and cyber
        security.
      </p>
      <p className="mb-6">
        This team is tasked with implementing and maintaining security measures,
        monitoring potential threats, and responding to incidents.
      </p>
      <p className="mb-6">
        They also conduct regular security assessments and audits to ensure
        compliance with industry standards and regulations.
      </p>
      <p className="mb-6">
        Right now this consists of Tanmay, Lokesh, and Kanik.
      </p>
      <h2 className="text-xl mt-8 mb-3 font-semibold">
        Policies and Role Responsibilities:
      </h2>
      <p className="mb-6">
        The responsibilities of our information/cyber security team include, but
        are not limited to:
      </p>
      <p className="mb-6">
        Developing and updating security policies and procedures.
      </p>
      <p className="mb-6">
        Conducting regular security assessments and audits.
      </p>
      <p className="mb-6">
        Monitoring network and system activity for potential threats.
      </p>
      <p className="mb-6">Responding to and managing security incidents.</p>
      <p className="mb-6">
        Providing security awareness training to employees.
      </p>
      <p className="mb-6">
        Ensuring compliance with relevant regulations, and standards.
      </p>

      <p className="mb-6">
        Our security policies and procedures are documented and made available
        to all relevant personnel. These documents outline the specific
        responsibilities of each role within the security team and the general
        security responsibilities of all employees.
      </p>
    </div>
  );
};

export default CrisisManagement;
